import React from 'react';
import { Dialog, DialogTrigger, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, Button } from '@fluentui/react-components';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message?: string | React.ReactNode;
  highlight?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, message, highlight, confirmText = 'Delete', cancelText = 'Cancel', onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onOpenChange={(_, data) => { if (!data.open) onCancel(); }}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          {message && 
          <DialogContent>
            {message}
            {highlight && (
            <p style={{ fontWeight: 'bold', marginTop: '1em' }}>
              {highlight}
            </p>
          )}
          </DialogContent>}
          
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel}>{cancelText}</Button>
            <Button appearance="primary" onClick={onConfirm}>{confirmText}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmDialog;